import { BN } from '@coral-xyz/anchor'

const DECIMAL_AMOUNT = /^(\d*)(?:\.(\d*))?$/

/**
 * A token amount in integer base units, counted digit by digit: float math
 * loses base units (`Math.floor(8.2 * 10 ** 6)` is 8199999). Digits past
 * `decimals` are dropped. A number is first written with `decimals` digits.
 */
export const toBaseUnits = (amount: string | number, decimals: number): BN => {
  const text =
    typeof amount === 'number' ? amount.toFixed(decimals) : amount.trim()
  const match = DECIMAL_AMOUNT.exec(text)

  if (!match || (!match[1] && !match[2])) {
    throw new Error(`Invalid token amount: ${amount}`)
  }

  const [, whole, fraction = ''] = match
  const digits =
    (whole || '0') + fraction.slice(0, decimals).padEnd(decimals, '0')

  return new BN(digits)
}
